import React from 'react';
import './DeleteTaskForm.scss';
import { closeDeleteTaskForm, deleteTask } from '../../../MainVIew/Tasks/taskSlice';


const DeleteTaskForm = (props) => {
    const { dispatch } = props;
 // CLICK OK
 
 const onSend = () => {
      
    console.log('Start delete task action');

        const data = {
            taskId: props.taskId,
            
        }

        dispatch(deleteTask(data));
       
    
       dispatch(closeDeleteTaskForm());
    }
    

    // CLOSE FORM
    const onClose = () => {
        const { dispatch } = props;
       
    dispatch(closeDeleteTaskForm());
    

    }


    const render = () => {

        
            return(
                <div className="DeleteTaskForm">
                    
                <p><b>Вы действительно хотите удалить задачу?</b></p>
                
                <button onClick={onSend}>Да</button>
                <button onClick={onClose}>Отмена</button>
                </div>
            )
       
   
    }
return render();
}
export default DeleteTaskForm;
  